export const CHAT_MESSAGES_ENDPOINT = '/c/v2/chat/messages';
export const CHAT_ASSISTANT_MESSAGES_ENDPOINT = '/c/v1/chat/assistant/messages';
export const GET_CHAT_MESSAGE_ATTACHMENTS_ENDPOINT =
  '/c/v1/chat/messages/:messageId/attachments';
